<template>
    <div>
        <h1>Policy Form</h1>
        <hr />

        <label for="date_effective">Effective Date</label>
        <DatePicker v-model="policy.date_effective" date-id="date_effective" />

        <label for="date_renewal">Renewal Date</label>
        <DatePicker v-model="policy.date_renewal" date-id="date_renewal" />

        <label for="date_due">Balance Due Date</label>
        <DatePicker v-model="policy.date_due" date-id="date_due" />

        <label for="policy_term">Term of Policy (months)</label>
        <b-form-spinbutton id="dpolicy_term" v-model="policy.policy_term" min="1" max="100"></b-form-spinbutton>
        <label for="policy_number" class="mt-2">Policy Number</label>
        <b-form-input v-model="policy.policy_number" placeholder="Enter the policy number"></b-form-input>
        <label for="policy_linesofcoverage_id" class="mt-2">Line of Coverage</label>
        <b-form-select v-model="policy.policy_linesofcoverage_id" :options="line_of_coverage"></b-form-select>
        <label for="coverage_line" class="mt-2">Coverage For</label>
        <b-form-select v-model="policy.coverage_line" :options="coverage_line_codes"></b-form-select>
        <label for="policy_types_id" class="mt-2">Risk Type</label>
        <b-form-select v-model="policy.policy_types_id" :options="risk_types"></b-form-select>
        <label for="policy_types_id" class="mt-2">Description of Risk:</label>
        <b-form-textarea id="textarea-default" placeholder="Default textarea"
            v-model="policy.description_of_risk"></b-form-textarea>
        <h2 class="mt-4">Cost and Fees</h2>
        <label for="premium_total_term" class="mt-2">Premium Total Term:</label>
        <b-form-input v-model="policy.premium_total_term" type="number"></b-form-input>
        <label for="policy_fees" class="mt-2">Policy Fees:</label>
        <b-form-input v-model="policy.policy_fees" type="number"></b-form-input>
        <label for="inspection_fees" class="mt-2">Inspection Fees:</label>
        <b-form-input v-model="policy.inspection_fees" type="number"></b-form-input>
        <label for="ga_broker_fees" class="mt-2">General Agent Broker Fees:</label>
        <b-form-input v-model="policy.ga_broker_fees" type="number"></b-form-input>
        <label for="stamp_fees" class="mt-2">Stamp Fees:</label>
        <b-form-input v-model="policy.stamp_fees" type="number"></b-form-input>
        <label for="tax_fees" class="mt-2">Tax Fees:</label>
        <b-form-input v-model="policy.tax_fees" type="number"></b-form-input>
        <label for="broker_fee" class="mt-2">Broker Fees:</label>
        <b-form-input v-model="policy.broker_fee" type="number"></b-form-input>
        <div class="my-3" v-if="pure_premium">
            <strong>Pure Premium:</strong> {{ pure_premium }}
        </div>
        <h2 class="mt-4">Commission</h2>
        <label for="commission_type" class="mt-2">Commission Type:</label>
        <b-form-select v-model="policy.commission_type" :options="policy_commission_type_codes"></b-form-select>
        <label for="commission_percentage" class="mt-2">Commission Percentage:</label>
        <b-form-input v-model="policy.commission_percent" type="number"></b-form-input>
        <!-- <label for="commission_amount" class="mt-2">Commission Amount:</label>
        <b-form-input v-model="policy.commission_amount" type="number"></b-form-input> -->
        <div class="my-3" v-if="commission_amount_display">
            <strong>Commission Amount:</strong> {{ commission_amount_display }}
        </div>
        <label for="commission_status" class="mt-2">Commission Status:</label>
        <b-form-select v-model="policy.commission_status_id" :options="policy_commission_status_codes"></b-form-select>
        <div class="my-3" v-if="net_income">
            <strong>Net income:</strong> {{ net_income }}
        </div>
        <div class="my-3" v-if="min_deposit">
            <strong>Minimum Deposit:</strong> {{ min_deposit }}
        </div>
        <h2 class="mt-4">Policy Details</h2>
        <label for="insurance_company_id" class="mt-2">Insurance Company:</label>
        <b-form-select v-model="insurance_company_id" :options="insurance_companies"></b-form-select>
        <label for="general_agents_id" class="mt-2">Agency:</label>
        <b-form-select v-model="agency_id" :options="agencies"></b-form-select>
        <label for="policy_status" class="mt-2">Policy Status:</label>
        <b-form-select v-model="policy.policy_status_id" :options="policy_status_codes"></b-form-select>
        <label for="user_id" class="mt-2">Sales Agent:</label>
        <b-form-select v-model="policy.user_id" :options="users"></b-form-select>
        <label for="writing_user_id" class="mt-2">Renewal Processor:</label>
        <b-form-select v-model="policy.writing_user_id" :options="users"></b-form-select>
        <label for="servicing_user_id" class="mt-2">Customer Service:</label>
        <b-form-select v-model="policy.servicing_user_id" :options="users"></b-form-select>
        <label for="policy_source_id" class="mt-2">Policy Source:</label>
        <b-form-select v-model="policy.policy_source_id" :options="policy_source_codes"></b-form-select>
        <label for="policy_source" class="mt-2">Business Source:</label>
        <b-form-select v-model="policy.policy_source" :options="policy_business_source_codes"></b-form-select>
        <hr />
        <label for="endorsement_note" class="mt-2">Endorsement Note:</label>
        <b-form-textarea id="textarea-default" placeholder="Endorsement Note"
            v-model="policy.endorsement_note"></b-form-textarea>
        <hr />
        <b-button variant="primary" @click="savePolicy" class="float-right">Save Policy</b-button>
    </div>
</template>

<script>
import ReferenceDataService from "@/services/ReferenceDataService";
import UserDataService from "@/services/UserDataService";
import PolicyDataService from "@/services/PolicyDataService";
import AspectDataService from "@/services/AspectDataService";
import DatePicker from '@/components/DatePicker.vue';

export default {
    components: {
        DatePicker
    },
    name: "PolicyForm",
    data() {
        return {
            policy: {},
            users: [],
            line_of_coverage: [],
            coverage_line_codes: [],
            risk_types: [],
            policy_status_codes: [],
            policy_source_codes: [],
            policy_commission_type_codes: [],
            policy_commission_status_codes: [],
            policy_business_source_codes: [],
            insurance_companies: [],
            agencies: [],
            agency_id: null,
            insurance_company_id: null,
            pure_premium: null,
            commission_amount: null,
            commission_amount_display: null,
            min_deposit: null,
            net_income: null,
        };
    },
    created() {
    const policyKey = this.$route.params.policy_key;

    if (policyKey) {
        PolicyDataService.getById(policyKey).then((res) => {
            if (res && res.data) {
                // Format all "date_" fields to MM/DD/YYYY
                Object.entries(res.data).forEach(([key, value]) => {
                    if (key.startsWith("date_") && value) {
                        const date = new Date(value);
                        if (!isNaN(date)) {
                            const mm = String(date.getMonth() + 1).padStart(2, "0");
                            const dd = String(date.getDate()).padStart(2, "0");
                            const yyyy = date.getFullYear();
                            res.data[key] = `${mm}/${dd}/${yyyy}`;
                        }
                    }
                });

                this.policy = { ...res.data, label: 'none' };
                this.doCalcs();
            }
        }).catch((err) => this.$emit("error", err));

        PolicyDataService.getAspects(policyKey)
            .then((res) => {
                if (res && res.data && Array.isArray(res.data)) {
                    res.data.forEach((aspect) => {
                        AspectDataService.getById(aspect.aspect_id).then((aspectRes) => {
                            if (aspectRes && aspectRes.data) {
                                if (aspect.relationship === "Insurance Company") {
                                    this.insurance_company_id = aspectRes.data.id;
                                } else if (aspect.relationship === "General Agent") {
                                    this.agency_id = aspectRes.data.id;
                                }
                            }
                        }).catch(() => {});
                    });
                }
            })
            .catch((err) => this.$emit("error", err));
    }

 const refCalls = [
  { method: ReferenceDataService.policy_linesofcoverage, target: 'line_of_coverage' },
  { method: ReferenceDataService.policy_risktype_codes, target: 'risk_types' },
  { method: ReferenceDataService.insurance_companies, target: 'insurance_companies' },
  { method: ReferenceDataService.agencies, target: 'agencies' },
  {
    method: ReferenceDataService.policy_status_codes,
    target: 'policy_status_codes',
    transform: (res) => res.map(obj => ({ value: obj.id, text: obj.label }))
  },
  {
    method: ReferenceDataService.policy_source_codes,
    target: 'policy_source_codes'
  },
  {
    method: ReferenceDataService.policy_business_source_codes,
    target: 'policy_business_source_codes'
  },
  {
    method: ReferenceDataService.policy_coverageline_codes,
    target: 'coverage_line_codes'
  },
  {
    method: ReferenceDataService.policy_commission_type_codes,
    target: 'policy_commission_type_codes'
  },
  {
    method: ReferenceDataService.policy_commission_status_codes,
    target: 'policy_commission_status_codes'
  }
];

refCalls.forEach(({ method, target, transform }) => {
  const result = method();

  if (result instanceof Promise) {
    result
      .then((res) => {
        this[target] = transform ? transform(res.data || res) : (res.data || res);
      })
      .catch((err) => this.$emit("error", err));
  } else {
    this[target] = transform ? transform(result) : result;
  }
});


    UserDataService.getActiveUsers().then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
            this.users = res.data;
        }
    }).catch((err) => this.$emit("error", err));
},
    watch: {
        agency_id: function (val) {
            this.policy.general_agents_id = val
        },
        insurance_company_id: function (val) {
            this.policy.insurance_company_id = val
        }
    },
    methods: {

        onContext(ctx) {
            // The date formatted in the locale, or the `label-no-date-selected` string
            this.formatted = ctx.selectedFormatted
            // The following will be an empty string until a valid date is entered
            this.selected = ctx.selectedYMD
        },
        savePolicy: function () {
            PolicyDataService.update(this.policy.id, this.policy).then((res) => {
                if (res && !res.status) {
                    window.location = `/policy/${this.policy.id}?update=true`;
                } else {
                    console.error('Failed to save policy:', res?.message);
                    this.$emit("error", res?.message || 'Failed to save policy');
                }
            }).catch((err) => {
                this.$emit("error", err);
            });
        },

        roundMoney: function (num) {
            num = parseFloat(num);
            let result = Math.round(num * 100);
            return (result / 100).toFixed(2);
        },
        doCalcs: function () {
            let premium = parseFloat(this.policy.premium_total_term); // do this
            let inspection_fees = parseFloat(this.policy.inspection_fees);
            let ga_broker_fees = parseFloat(this.policy.ga_broker_fees);
            let stamp_fees = parseFloat(this.policy.stamp_fees);
            let tax_fees = parseFloat(this.policy.tax_fees);
            let policy_fees = parseFloat(this.policy.policy_fees);
            let broker_fee = parseFloat(this.policy.broker_fee);

            let all_fees =
                stamp_fees +
                policy_fees +
                broker_fee +
                inspection_fees +
                ga_broker_fees +
                tax_fees;

            this.pure_premium = "$" + this.roundMoney(premium - all_fees);

            let PolicyCommissionType = this.policy.commission_type;
            if (PolicyCommissionType === "percent") {
                this.test_calc = true;

                let commission_percent = parseFloat(this.policy.commission_percent);
                this.commission_amount_display =
                    "$" +
                    this.roundMoney((premium - all_fees) * commission_percent * 0.01);
                this.net_income =
                    "$" +
                    this.roundMoney(
                        (premium - all_fees) * commission_percent * 0.01 + broker_fee
                    );
            } else {
                this.net_income =
                    "$" +
                    this.roundMoney(
                        parseFloat(this.policy.commission_amount) + broker_fee
                    );
            }

            this.min_deposit =
                "$" +
                this.roundMoney(
                    (premium - stamp_fees - policy_fees - broker_fee) * 0.35 +
                    policy_fees +
                    stamp_fees +
                    broker_fee
                );
        },
    },
};
</script>